import {version} from '../../package.json';
import { namespace } from './common/Utils';
import Smartbanner from './md-smartBanner';
import CommunityBanner from './md-communityBanner';
import CommunityImageBanner from "./md-communityImageBanner";
import Tab from './md-tab';
import Commonbanner from './md-commonBanner';
import ProfileImgUpload from './md-profileImgUpload';
import MyCharList from './md-myCharList';
import Footer from './md-footer';
import IdVerify from './md-idVerify';
import Dropdown from './md-dropdown';
import {ConfirmToastIndex, SettingLayerIndex} from './md-cookieLayer';
import AutoSuggest from './md-autoSuggest';
import Modal from './md-modal';
import Share from './md-share';
import Captcha from './md-captcha';
import Timezone from './md-timezone';
import RankKeyword from './md-rankKeyword';
import Chatbot from "./md-chatbot";
import AgeGate from "./md-ageGate";
import Newsletter from "./md-newsletter";

namespace('ncui');
namespace('ncui.cookieLayer');

window.ncui.ver = version;
window.ncui.smartbanner = Smartbanner;
window.ncui.communityBanner = CommunityBanner;
window.ncui.communityImageBanner = CommunityImageBanner;
window.ncui.tab = Tab;
window.ncui.commonBanner = Commonbanner;
window.ncui.profileImgUpload = ProfileImgUpload;
window.ncui.myCharList = MyCharList;
window.ncui.footer = Footer;
window.ncui.idVerify = IdVerify;
window.ncui.dropdown = Dropdown;
window.ncui.cookieLayer.confirmToast = ConfirmToastIndex;
window.ncui.cookieLayer.settingLayer = SettingLayerIndex;
window.ncui.autoSuggest = AutoSuggest;
window.ncui.modal = Modal;
window.ncui.share = Share;
window.ncui.captcha = Captcha;
window.ncui.timezone = Timezone;
window.ncui.rankKeyword = RankKeyword;
window.ncui.chatbot = Chatbot;
window.ncui.ageGate = AgeGate;
window.ncui.newsletter = Newsletter;
